import { Controller } from "@hotwired/stimulus"

// Coordinates a "select all" checkbox, per-row checkboxes, and a bulk-delete
// button + hidden form. Used on index tables that support bulk delete.
export default class extends Controller {
  static targets = ["selectAll", "checkbox", "deleteButton", "form", "idsContainer"]

  toggleAll() {
    this.checkboxTargets.forEach((checkbox) => { checkbox.checked = this.selectAllTarget.checked })
    this.refresh()
  }

  toggle() {
    if (this.hasSelectAllTarget) {
      this.selectAllTarget.checked = this.checkboxTargets.every((checkbox) => checkbox.checked)
    }
    this.refresh()
  }

  refresh() {
    const anySelected = this.checkboxTargets.some((checkbox) => checkbox.checked)
    this.deleteButtonTarget.classList.toggle("d-none", !anySelected)
  }

  submit() {
    const ids = this.checkboxTargets.filter((checkbox) => checkbox.checked).map((checkbox) => checkbox.value)
    if (ids.length === 0) return
    if (!confirm(`Delete ${ids.length} selected item(s)? This cannot be undone.`)) return

    this.idsContainerTarget.innerHTML = ""
    ids.forEach((id) => {
      const input = document.createElement("input")
      input.type = "hidden"
      input.name = "ids[]"
      input.value = id
      this.idsContainerTarget.appendChild(input)
    })
    this.formTarget.requestSubmit()
  }
}
